import { membershipApi } from "@bw/shared/api";
import { useEphemeralSubscriptionMutation } from "./useEphemeralSubscriptionMutation";

/**
 * Reconcile a first-charge subscription against Stripe AFTER the FE completes
 * 3-D Secure (SCA) via `stripe.confirmCardPayment` (POST
 * /memberships/{id}/confirm). The backend retrieves the LIVE Stripe
 * subscription and returns the authoritative state — 'active' ONLY when the
 * charge actually cleared, otherwise still 'incomplete'. The FE shows success
 * only when the returned sub is active; a still-incomplete result surfaces an
 * honest retry.
 *
 * On success the caller's `mine` + `visitBalances` arms are invalidated so My
 * Memberships (and any newly minted pass balance) reflect server truth.
 */
export function useConfirmSubscription() {
  return useEphemeralSubscriptionMutation(
    (subscriptionId: string) =>
      membershipApi.confirmSubscription(subscriptionId),
    (subscriptionId) => subscriptionId,
  );
}
